import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'atlasCurrency',
  standalone: false
})
export class AtlasCurrencyPipe implements PipeTransform {
  transform(value: number, includeSymbol = true): string {
    let returnValue = includeSymbol ? '$' : '';
    if (!value) {
      returnValue += '0.00';
    } else if (value < 0) {
      returnValue +=
        '(' +
        value
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
          .replace('-', '') +
        ')';
    } else {
      returnValue += value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
    return returnValue;
  }
}
